<template>
  <b-modal
    id="image_modal"
    @show="onShow"
    @hide="onClose"
    hide-header
    hide-footer
    centered
    body-class="text-center"
  >
    <div v-if="hasMultipleImages">

      <span class="position-absolute image-counter">
        {{ currentIndex + 1 }} / {{ totalImages }}
      </span>

      <div class="position-absolute info-image" v-if="currentImage.unit_name">
        <p class="mb-0">{{ currentImage.unit_name }} - {{ currentImage.camera_name }}</p>
        <p class="mb-0">{{ currentImage.date }}</p>
        <p v-if="currentImageName" class="mb-0 image-name" :title="currentImageName">
          {{ currentImageName }}
        </p>
      </div>
      <b-button
        variant="link"
        class="position-absolute left-arrow"
        @click="prevImage"
      >
        ‹
      </b-button>

      <vue-image-zoomer
        :regular="currentImage.url"
        :zoom-amount="3"
        :click-zoom="true"
        img-class="img-fluid modal-zoom-img"
      />

      <b-button
        variant="link"
        class="position-absolute right-arrow"
        @click="nextImage"
      >
        ›
      </b-button>
    </div>
    <div v-else>
      <vue-image-zoomer
        :regular="image"
        :zoom-amount="3"
        :click-zoom="true"
        img-class="img-fluid modal-zoom-img"
      />
    </div>

    <div class="ai-comment-container" v-if="aIcomment">
      <span class="ai-comment-title">Created by AI.</span>
      <div class="">{{ aIcomment }}</div>
    </div>
  </b-modal>
</template>

<script>
import store from "@/store";
import VueImageZoomer from 'vue-image-zoomer';

export default {
  components: {
    VueImageZoomer,
  },
  data() {
    return {
      image: '',
      aIcomment: '',
    };
  },
  computed: {
    getImage() {
      return store.state.image_modal.url;
    },
    getComment() {
      return store.state.image_modal.aiComment;
    },
    currentImage() {
      return store.state.image_modal.images[store.state.image_modal.index]
    },
    currentImageName() {
      const currentImage = this.currentImage || {};
      const explicitName =
        currentImage.name ||
        currentImage.file_name ||
        currentImage.filename ||
        currentImage.image_name;

      if (explicitName) return explicitName;
      if (!currentImage.url) return "";

      try {
        const parsedUrl = new URL(currentImage.url, window.location.origin);
        const filePath =
          parsedUrl.searchParams.get("fileName") ||
          parsedUrl.searchParams.get("filename") ||
          parsedUrl.pathname;

        return decodeURIComponent(filePath.split(/[\\/]/).filter(Boolean).pop() || "");
      } catch {
        return currentImage.url.split("?")[0].split("/").pop() || "";
      }
    },
    hasMultipleImages() {
      return store.state.image_modal.images.length > 1;
    },
    currentIndex() {
      return store.state.image_modal.index;
    },
    totalImages() {
      return store.state.image_modal.images.length;
    },
  },
  methods: {
    onShow() {
      this.image = this.getImage;
      this.aIcomment = this.getComment;

      this.total = store.state.image_modal.images.length;
      this.current = store.state.image_modal.index
    },
    onClose() {
      store.dispatch("image_modal/aiComment", '');
      store.dispatch("image_modal/imageList", []);
      store.dispatch("image_modal/imageIndex", 0);
    },
    nextImage() {
      const total = store.state.image_modal.images.length;
      const current = store.state.image_modal.index;
      const next = (current + 1) % total;
      store.dispatch("image_modal/imageIndex", next);
    },
    prevImage() {
      const total = store.state.image_modal.images.length;
      const current = store.state.image_modal.index;
      const prev = (current - 1 + total) % total;
      store.dispatch("image_modal/imageIndex", prev);
    }
  }
};
</script>

<style>
.ai-comment-container {
  text-align: start;
  margin: 10px 0;
}
.ai-comment-title {
  font-weight:bolder;
  font-size: 14px;
}
.image-wrapper {
  position: relative;
  display: inline-block;
  max-width: 100%;
}

#image_modal .modal-dialog {
  width: fit-content;
  max-width: 95vw;
}

#image_modal .vh--outer {
  display: inline-block;
  max-width: 100%;
}
#image_modal .vh--holder {
  max-width: 100%;
}

/* Scales small pictures up (snapshots arrive at 640x360) keeping their ratio:
   only min-height is set, and it is capped against the viewport width so it can
   never fight max-width — two active constraints would distort the image */
#image_modal .modal-zoom-img {
  width: auto;
  height: auto;
  max-width: 100%;
  min-height: min(65vh, 50vw);
  max-height: 88vh;
}

#image_modal .left-arrow,
#image_modal .right-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  padding: 0;
  font-size: 2rem;
  line-height: 1;
  color: white;
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 50%;
  z-index: 10;
  border: none;
}

.left-arrow {
  left: 10px;
}

.right-arrow {
  right: 10px;
}

#image_modal .image-counter {
  top: 10px;
  left: 10px;
  z-index: 10;
  padding: 0.25rem 0.5rem;
  color: white;
  font-size: 0.9rem;
  border-radius: 0.25rem;
  background-color: rgba(0, 0, 0, 0.4);
}

.info-image {
  position: absolute;
  transform: translateY(-50%);
  font-size: 1rem;
  color: white;
  background-color: rgba(0, 0, 0, 0.4);
  padding: 0.5rem;
  z-index: 10;
  border: none;
  top: 10%;
}

#image_modal .image-name {
  max-width: 24rem;
  overflow-wrap: anywhere;
  font-size: 0.85rem;
}
</style>
